import { TRANSFER } from '../actions';
import moment from 'moment';

const initialState = {
  minDate: moment('2019-01-01'),
  maxDate: moment(),
  startDate: moment('2019-01-01'),
  endDate: moment(),
  companyId: 'Select all',
  deviceReceipt: 'Select all',
  qrType: 'Select all',
  account: 'Select all',
  status: 'Select all',
  isFetching: false,
  data: null,
  isFetched: false,
  isError: false,
  dataError: null
};

export default (state = initialState, { type, payload, error }) => {
  switch (type) {
    case TRANSFER.TRANSFER_COMPANY_CHANGE:
      return { ...state, companyId: payload };

    case TRANSFER.TRANSFER_RECEIPT_CHANGE:
      return { ...state, deviceReceipt: payload };

    case TRANSFER.TRANSFER_QR_TYPE_CHANGE:
      return { ...state, qrType: payload };

    case TRANSFER.TRANSFER_ACCOUNT_CHANGE:
      return { ...state, account: payload };

    case TRANSFER.TRANSFER_START_DATE_CHANGE:
      return { ...state, startDate: payload };

    case TRANSFER.TRANSFER_END_DATE_CHANGE:
      return { ...state, endDate: payload };

    case TRANSFER.TRANSFER_STATUS_CHANGE:
      return { ...state, status: payload };

    case TRANSFER.GET_TRANSFER_PENDING:
      return {
        ...state,
        isFetching: true,
        data: null,
        isFetched: false,
        isError: false,
        dataError: null
      };

    case TRANSFER.GET_TRANSFER_SUCCESS:
      return { ...state, isFetching: false, data: payload, isFetched: true };

    case TRANSFER.GET_TRANSFER_FALIED:
      return {
        ...state,
        isFetching: false,
        data: null,
        isFetched: false,
        isError: true,
        dataError: error
      };

    default:
      return state;
  }
};
